import Vue from 'vue'
import App from './App.vue'
import router from './router'                       // 存放著Vue Router
import store from './store'                         // 存放著VueX
import axios from 'axios'                           // 使用axios
import VueAxios from 'vue-axios'                    // 使用vue-axios
import BootstrapVue from 'bootstrap-vue'            // bootstrap
import VueAwesomeSwiper from 'vue-awesome-swiper'   // Swiper

import 'bootstrap/dist/css/bootstrap.css'           // bootstrap
import 'bootstrap-vue/dist/bootstrap-vue.css'       // bootstrap
import 'swiper/dist/css/swiper.css'                  // Swiper
import './styles/front_end.scss'                    // Frontend

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(VueAwesomeSwiper);
Vue.use(VueAxios, axios);

import './assets/application.js'

new Vue({
  router, // Vue Router
  store,  // VueX
  render: h => h(App),
}).$mount('#app')
